<template>
    <v-container fluid>
        <v-row>
            <v-col class="pl-5" cols="12">
                <v-btn
                    v-if="inEditMode && documentChecklist.id != 0"
                    class="ml-2 mr-2"
                    color="primary"
                    @click="saveClick(null)"
                >
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
                </v-btn>
                <v-btn
                    v-if="!inEditMode && !application.gdpr_edit_lock"
                    class="ml-2 mr-2"
                    color="primary"
                    @click="editClick()"
                >
                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                </v-btn>
            </v-col>
            <v-col class="pl-5">
                <v-btn
                    v-if="inEditMode && documentChecklist.id != 0 && !application.gdpr_edit_lock"
                    class="ml-2 mr-2"
                    color="primary"
                    @click="pullDocuments(null)"
                >
                    <v-icon small>fas fa-file-import</v-icon>&nbsp;{{ $t('buttons.pullDocuments') }}
                </v-btn>
            </v-col>
            <v-col class="pl-5 text-right">
                <v-btn
                    v-if="inEditMode || (documentChecklist.id == 0 && !application.gdpr_edit_lock)"
                    class="ml-2 mr-2"
                    color="primary"
                    @click="updateList(null)"
                >
                    <v-icon small>fas fa-sync</v-icon>&nbsp;{{ $t('buttons.updateList') }}
                </v-btn>
                <v-col v-if="updated != ''" class="pl-5 text-right">
                    {{ $t('labels.checklistLastUpdated') }} {{ updated }}
                </v-col>
            </v-col>
        </v-row>
        <v-row
            style="
                margin-top: 3px;
                margin-bottom: 0px;
                scroll-margin: 0px;
                height: 76vh;
                overflow-y: scroll;
                overflow-x: hidden;
            "
        >
            <v-col cols="12">
                <v-row>
                    <v-col v-for="n in 3" cols="12" :key="n">
                        <ApplicationChecklistPhase
                            :phase="n"
                            :application="application"
                            :documentChecklist="documentChecklist"
                            :inEditMode="inEditMode"
                            :key="componentKey"
                        ></ApplicationChecklistPhase>
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="12">
                <v-card flat>
                    <v-card-text
                        ><v-row dense>
                            <v-col cols="12">
                                <TextArea
                                    :readonly="!inEditMode"
                                    :maxlength="1000"
                                    v-model="documentChecklist.additional_info"
                                    :label="$t('fields.additionalInformation')"
                                    :key="componentKey"
                                ></TextArea>
                            </v-col> </v-row></v-card-text
                ></v-card>
            </v-col>
        </v-row>
        <v-row><v-col></v-col></v-row>
    </v-container>
</template>

<script>
import TextArea from '@/components/trinkets/TextArea';
import ApplicationDocumentChecklist from '../models/ApplicationDocumentChecklist';
import ApplicationChecklistPhase from './ApplicationChecklistPhase.vue';

export default {
    name: 'DocumentChecklist',
    components: {TextArea, ApplicationChecklistPhase},
    data: function () {
        return {
            documentChecklist: new ApplicationDocumentChecklist({}),
            documentChecklistValidation: new ApplicationDocumentChecklist({}, true),
            initialLoad: false,
            lockKey: 'application-checklist',
            lockTimer: null,
            componentKey: 1,
            updated: '',
        };
    },
    props: ['application', 'inEditMode'],
    watch: {},

    methods: {
        updateList() {
            let vm = this;
            this.$verify(this.$t('alerts.updateListQuestion'), (result) => {
                if (result) {
                    let checklistId = this.application.id;
                    this.$APICall(
                        'post',
                        'application-document-checklist-update/' + this.application.id,
                        {checklistId},
                        (data, succes) => {
                            if (succes) {
                                let usableData = JSON.parse(JSON.stringify(data));
                                if (!usableData.message) {
                                    vm.documentChecklist = usableData.document_checklist;
                                    vm.updated = usableData.updated;
                                    vm.componentKey += 1;
                                    clearInterval(vm.lockTimer);
                                    vm.$removeLock(vm, vm.lockKey + '|' + vm.documentChecklist.id);
                                    vm.inEditMode = false;
                                } else {
                                    vm.$alert(vm.$t('alerts.noChecklistDefinedOnMaritimeObject'));
                                }
                            } else {
                                vm.$alert(vm.$t('alerts.basicError'));
                            }
                        },
                    );
                }
            });
        },

        pullDocuments() {
            let vm = this;
            this.$verify(this.$t('alerts.updateListQuestion'), (result) => {
                if (result) {
                    let checklistId = this.documentChecklist.id;
                    this.$APICall(
                        'post',
                        'application-document-checklist-update/' + this.application.id,
                        {checklistId},
                        (data, succes) => {
                            if (succes) {
                                let usableData = JSON.parse(JSON.stringify(data));
                                if (!usableData.message) {
                                    vm.documentChecklist = usableData.document_checklist;
                                    vm.updated = usableData.updated;
                                    vm.componentKey += 1;
                                    clearInterval(vm.lockTimer);
                                    vm.$removeLock(vm, vm.lockKey + '|' + vm.documentChecklist.id);
                                    vm.inEditMode = false;
                                } else {
                                    vm.$alert(vm.$t('alerts.noChecklistDefinedOnMaritimeObject'));
                                }
                            } else {
                                vm.$alert(vm.$t('alerts.basicError'));
                            }
                        },
                    );
                }
            });
        },

        editClick() {
            let vm = this;
            this.$setLock(this, this.lockKey + '|' + this.documentChecklist.id, (data) => {
                if (data.success) {
                    vm.inEditMode = true;
                    vm.lockTimer = setInterval(() => {
                        vm.$setLock(vm, vm.lockKey + '|' + vm.documentChecklist.id);
                    }, 10000);
                } else {
                    vm.$alert(
                        vm
                            .$t('alerts.recordLocked')
                            .split('%name%')
                            .join(data.locked_by.first_name + ' ' + data.locked_by.last_name),
                    );
                }
            });
        },
        backClick() {
            this.$router.go(-1);
        },

        saveClick() {
            let vm = this;
            this.inEditMode = false;
            clearInterval(this.lockTimer);
            this.$removeLock(vm, vm.lockKey + '|' + vm.documentChecklist.id);
            this.$triggerReload();
        },
        beforeRouteLeave(to, from, next) {
            if (this.inEditMode) {
                let vm = this;
                this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                    if (result) {
                        if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
                        vm.$removeLock(vm, vm.lockKey + '|' + vm.documentChecklist.id);
                        next(true);
                    } else {
                        next(false);
                    }
                });
            } else {
                if (this.lockTimer !== null) clearInterval(this.lockTimer);
                this.$removeLock(this, this.lockKey + '|' + this.documentChecklist.id);
                next(true);
            }
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        let vm = this;
        this.$APICall('get', 'application-document-checklists/' + this.application.id, {}, (data, success) => {
            if (success) {
                let usableData = JSON.parse(JSON.stringify(data));
                vm.documentChecklist = usableData.item;
                vm.updated = usableData.updated;
                vm.componentKey += 1;
            } else {
                vm.inEditMode = false;
                vm.initialLoad = true;
            }
        });
    },
};
</script>

<style scoped></style>
